




































































































  import { Component, Vue } from 'vue-property-decorator'
  import MainHeader from '@/components/MainHeader'
import {getRegionListRequest,getIndustryListRequest,getSupervisionCompanyListRequest} from '@/api/msgEnterprise'
import {getLocalItem } from '@/utils'
// import moment from 'moment'

  @Component({
      components:{
          MainHeader
      }
  })
  export default class Login  extends Vue {
    private regionList:any[]=[]
    private industryList:any=[]
    private emptyText='暂无数据'
    private replaceIndustryFields:any={children:'childList', title:'industryName', key:'id', value: 'industryCode' }
    private replaceFields:any={children:'childList', title:'regionName', key:'id', value: 'regionCode' }
    private client:any =getLocalItem('client')
//  private user:any =getLocalItem('user')
    private searchParams:any={
    custId:null,//客户id
    // superviseType:0,
    regionCode:null,
    industryCode:null,
    enterpriseName:null,
  }
    private pageOption={
     showTotal: (total:any) => `共 ${total} 条`,
     current:1,
     total:0,
     pageSize:10,
     defaultPageSize:10
  }
  private loading:boolean=false;
   private columns:any = [{
    title: '企业',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    ellipsis: true
  },
  {
    title: '所属地区',
    dataIndex: 'regionName',
    key: 'regionName',
     customRender: (text:any, row:any, index:any) => {
      return text? text : '-'
    }
  },
  {
    title: '所属行业',
    dataIndex: 'industryName',
    key: 'industryName',
     ellipsis: true,
     customRender: (text:any, row:any, index:any) => {
      return text? text : '-'
    }
  },
 {
    title: '操作',
    key: 'operation',
    width: 150,
    scopedSlots: { customRender: 'action' },
  }]
  private dataSource:any = [];
  getSupervisionCompanyList(params:any){
    const searchData:any={}
    Object.assign(searchData,params)
    searchData.size=this.pageOption.pageSize
    searchData.current=this.pageOption.current
    this.loading=true
        getSupervisionCompanyListRequest(searchData).then((res:any)=>{
            if(res.status == 0 ){
                this.dataSource=res.data.records
                this.pageOption.total=res.data.total
            }else{
                this.$message.error(res.message || '获取失败')
            }
            this.loading=false
        }).catch(()=>{
            
        })
    }
  superviseProgressTypeFun(row:any){
    if(!row.superviseTime){
      return true
    }
    const date = new Date(row.superviseTime)
    if(date.getFullYear() == new Date().getFullYear()){
      return false
    }else{
      return true
    }
  }
  getRegionList(e:any){
    getRegionListRequest({regionCode: e}).then((res:any)=>{
      const {status,data,messsage}=res
      if(res.status==0){
        this.regionList=[data]
      }
    })
  }
  getIndustryList(e:any){
    getIndustryListRequest({Authorization:e}).then((res:any)=>{
      if(res.status==0){
        this.industryList=res.data
      }
    })
  }
  handleSuperviseType(id:number){
    // this.searchParams.superviseType=id
    this.getSupervisionCompanyList(this.searchParams)
  }
  handleSearch(){
    this.pageOption.current=1
    this.getSupervisionCompanyList(this.searchParams)
  }
  handleResert(){
    this.pageOption.current=1
    this.searchParams = {}
    this.getSupervisionCompanyList(this.searchParams)
  }
  handleTableChange(page:any){
    this.pageOption.current=page.current
    this.getSupervisionCompanyList(this.searchParams)
    
  }
  handleView(obj:any){
    this.$router.push({
      name:'CompanyInfo',
      query: {name: obj.enterpriseName,code: obj.id,action:'edit',year:(new Date().getFullYear()).toString(),encode:obj.enterpriseCode}
    })
  }
  created(){
    const userT=Vue.ls.get('ACCESS_TOKEN')
    const regionCode: string=this.client.custRegionCode
    this.getSupervisionCompanyList(this.searchParams)
    this.getRegionList(regionCode)
    this.getIndustryList(userT)
 }
}
